
/**
 * Représente les rôles
 */
export class Roles {
    public static MRAdministrateur: string = 'MR.Administrateur';
    public static MRInterne: string = 'MR.Interne';
}
